<template>
  <div id="app" class="app-container">
    <RootMenu></RootMenu>
    <div class="flex-container">
      <div class="right-aligned-div" />
    </div>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-row">
        <div class="search-field">
          <label for="cpmc">产品名称：</label>
          <input
            id="cpmc"
            v-model="cpmc"
            type="text"
            class="search-input"
            @keyup.enter="checkLoginBeforeSearch"
            placeholder="去掉R角标符号模糊查询"
          >
        </div>

        <div class="search-field">
          <label for="approvalText">批准文号：</label>
          <input
            id="approvalText"
            v-model="approvalText"
            type="text"
            @keyup.enter="checkLoginBeforeSearch"
            class="search-input"
          >
        </div>
      </div>

      <div class="search-row">
        <div class="search-field">
          <label for="healthFunction">保健功能：</label>
          <input
            id="healthFunction"
            v-model="healthFunction"
            type="text"
            @keyup.enter="checkLoginBeforeSearch"
            class="search-input"
            placeholder="多个功能可以用空格隔开"
          >
        </div>

        <div class="search-field">
          <label for="mainIngredients">主要原料：</label>
          <input
            id="mainIngredients"
            v-model="mainIngredients"
            type="text"
            @keyup.enter="checkLoginBeforeSearch"
            class="search-input"
            placeholder="多个原料可以用空格隔开"
          >
        </div>
      </div>

      <div class="search-row">
        <div class="search-field">
          <label for="productionEnterprise">申请人中文名称：</label>
          <input
            id="productionEnterprise"
            v-model="productionEnterprise"
            type="text"
            @keyup.enter="checkLoginBeforeSearch"
            class="search-input"
          >
        </div>

        <div class="search-field">
          <label for="gxcf">功效成分：</label>
          <input
            id="gxcf"
            v-model="gxcf"
            type="text"
            @keyup.enter="checkLoginBeforeSearch"
            class="search-input"
            placeholder="多个功效可以用空格隔开"
          >
        </div>
      </div>

      <!-- 高级查询按钮 -->
      <div class="advanced-search-toggle">
        <el-button
          @click="checkLoginBeforeAdvancedSearch"
          type="text"
          class="advanced-search-btn"
        >
          {{ showAdvanced ? '收起高级查询' : '展开高级查询' }}
          <i :class="showAdvanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>

      <!-- 高级查询区域 -->
      <div v-if="showAdvanced" class="advanced-search-panel">
        <!-- 排序方式（全局排序保留，但可被多字段排序覆盖） -->
        <div class="sort-section">
          <h4>全局排序（与下列字段排序互斥）</h4>
          <div class="search-field">
            <label for="sortOption">排序方式：</label>
            <el-select
              id="sortOption"
              v-model="sortOption"
              placeholder="请选择排序方式"
              class="sort-select"
              clearable
              @change="handleGlobalSortChange"
            >
              <el-option label="按功效成分含量由高到低" value="hl"></el-option>
              <el-option label="按保健功能由高到低" value="sl"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 功效成分对话框查询 -->
        <div class="dialog-search-section">
          <h4>功效成分精确查询</h4>
          <div class="dialog-search-row">
            <div class="dialog-search-field">
              <label>成分名称：</label>
              <el-input
                v-model="ingredientName"
                placeholder="请输入功效成分名称"
                clearable
                class="dialog-input"
              />
            </div>
            <div class="dialog-search-field">
              <label>成分含量：</label>
              <el-input
                v-model="ingredientValue"
                placeholder="请输入成分含量"
                clearable
                class="dialog-input"
              />
            </div>
          </div>
        </div>

        <!-- 有效期至查询 -->
        <div class="date-search-section">
          <h4>有效期至查询</h4>
          <div class="search-field date-field">
            <label for="yxqz">有效期至：</label>
            <select v-model="symbol" class="symbol-select">
              <option selected value="=">等于</option>
              <option value=">=">大于等于</option>
              <option value="<=">小于等于</option>
            </select>
            <div class="date-pickers">
              <el-date-picker
                v-model="yxqz"
                type="month"
                placeholder="选择年月"
                value-format="YYYY-MM"
                class="date-picker"
              />
              <el-date-picker
                v-model="yxqz"
                type="date"
                placeholder="选择年月日"
                value-format="YYYY-MM-DD"
                class="date-picker"
              />
            </div>
          </div>
        </div>

        <!-- 技术要求检索（FTS5 全文检索） -->
        <div class="tech-requirement-section">
          <h4>技术要求检索</h4>
          <div class="search-field">
            <label for="techRequirement">技术要求：</label>
            <el-input
              v-model="techRequirement"
              placeholder='多词以空格分隔（OR），"+" 表示必须包含，"-" 表示排除。如：心脏 免疫 +维生素 -减肥'
              class="tech-req-input"
              clearable
            />
          </div>
        </div>

        <!-- 动态查询条件（同时作为动态显示列） -->
        <div class="dynamic-conditions-section">
          <h4>自定义查询条件（同时作为动态显示列）</h4>
          <div class="dynamic-conditions">
            <div v-for="(condition, index) in conditions" :key="index" class="condition-item">
              <el-select
                v-model="condition.field"
                filterable
                placeholder="请选择查询字段"
                class="condition-select"
                @change="updateDynamicColumns"
              >
                <el-option
                  v-for="item in fieldOptions"
                  :key="item.value"
                  :label="item.commitName"
                  :value="item.columnName"
                />
              </el-select>

              <el-input
                v-model="condition.value"
                placeholder="请输入查询值"
                class="condition-input"
              />

              <el-button @click="removeCondition(index)" type="danger" icon="el-icon-delete" circle class="remove-btn">一</el-button>
            </div>
          </div>
          <el-button @click="addCondition" type="primary" class="add-condition-btn"> + 添加条件</el-button>
        </div>
      </div>

      <!-- 搜索按钮组 -->
      <div class="search-actions">
        <div class="button-group">
          <button class="search-btn original-style" @click="checkLoginBeforeSearch">搜索</button>
          <button class="reset-btn original-style" @click="resetSearch">重置</button>
          <!-- 当前页批量添加批文库（未登录点击弹出登录窗口）；固定宽度容器防止 el-select 被 flex 拉伸 -->
          <div class="batch-pwk-select-wrap">
            <el-select
              v-model="batchPwkSelected"
              placeholder="当前页批量添加批文库"
              style="width: 100%"
              popper-width="280"
              @visible-change="handleBatchSelectVisible"
              @change="handleBatchPwkSelect"
            >
              <el-option
                v-for="lib in pwkLibs"
                :key="lib.id"
                :label="lib.pwkName + (lib.isDefault === 1 ? '（默认）' : '')"
                :value="lib.id"
              />
              <el-option label="＋ 新建批文库" value="new" />
            </el-select>
          </div>
          <button class="export-btn original-style" @click="exportData" v-if="showAdvanced && isAdmin">导出</button>
        </div>
      </div>
    </div>

    <!-- 未登录提示横幅：登录显示全部内容 -->
    <div v-if="showLoginPrompt" class="login-prompt-banner">
      <span class="prompt-text">登录显示全部内容</span>
      <a href="javascript:;" class="prompt-login-link" @click="handlePromptLogin">登录</a>
      <span class="prompt-sub">登录后可查看完整列表、使用备注与批文库功能</span>
    </div>

    <!-- 表格内容（动态表头，支持多字段排序） -->
    <div class="table-container">
      <div class="table-responsive">
        <table class="scrollable-table original-table">
          <thead>
            <tr>
              <!-- 固定列：产品名称（无排序，但可点击） -->
              <th>产品名称</th>

              <!-- 批准文号列：带排序下拉 -->
              <th>
                <div class="th-content">
                  <span>批准文号</span>
                  <select v-model="sortOrders.pzwh" @change="handleFieldSortChange" class="sort-select-inline">
                    <option value="">排序</option>
                    <option value="asc">↑ 升序</option>
                    <option value="desc">↓ 降序</option>
                  </select>
                </div>
              </th>

              <!-- 动态列：根据conditions生成，每个列头带排序下拉 -->
              <th v-for="(col, idx) in dynamicColumns" :key="'dyn-'+idx">
                <div class="th-content">
                  <span>{{ getColumnLabel(col.field) }}</span>
                  <select v-model="sortOrders[col.field]" @change="handleFieldSortChange" class="sort-select-inline">
                    <option value="">排序</option>
                    <option value="asc">↑ 升序</option>
                    <option value="desc">↓ 降序</option>
                  </select>
                </div>
              </th>

              <!-- 非 FTS 模式：显示原有列；FTS 模式：合并为一列显示技术要求匹配片段 -->
              <template v-if="!isFtsMode">
                <th class="mobile-hide">主要原料</th>
                <th class="mobile-hide">保健功能</th>
                <th class="mobile-hide">食用方法及食用量</th>
                <th class="mobile-hide">申请人中文名称</th>

                <!-- 功效成分列：带排序下拉 -->
                <th>
                  <div class="th-content">
                    <span>功效成分/标志性成分含量</span>
                    <select v-model="sortOrders.gxcf" @change="handleFieldSortChange" class="sort-select-inline">
                      <option value="">排序</option>
                      <option value="asc">↑ 升序</option>
                      <option value="desc">↓ 降序</option>
                    </select>
                  </div>
                </th>
              </template>
              <template v-else>
                <th>技术要求（命中片段）</th>
              </template>

              <th>详情</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <!-- 产品名称：可点击，蓝色；悬浮展示备注 -->
              <td @mouseenter="handleRowMouseEnter(item, $event)" @mouseleave="handleRowMouseLeave">
                <span class="clickable-name" @click="handleProductNameClick(item.id)">{{ item.cpmc }}</span>
              </td>

              <!-- 批准文号（带换证标志） -->
              <td class="approval-number-cell">
                <span v-if="item.changeCertificate == 1" class="tooltip-wrapper">
                  <img src="../../public/static/image/huanzheng.png" alt="换证标志" class="certificate-flag flag-icon">
                  <span class="tooltip-trigger">{{ item.pzwh }}</span>
                  <div class="tooltip-content">
                    <p>该批文为需要清理证批文，根据国家相关政策换证截止时间为2028年8月31日</p>
                    <a href="https://www.likangkeji.com/doubleNoList" target="_blank" class="tooltip-link">查看详情</a>
                  </div>
                </span>
                <span v-else>{{ item.pzwh }}</span>
              </td>

              <!-- 动态列数据 -->
              <td v-for="(col, idx) in dynamicColumns" :key="'dyn-val-'+idx">
                {{ item[col.field] || '—' }}
              </td>

              <!-- 剩余固定列数据：非 FTS 模式显示原有 5 列；FTS 模式合并为技术要求 snippet -->
              <template v-if="!isFtsMode">
                <td class="mobile-hide">{{ item.zyyl }}</td>
                <td class="mobile-hide">{{ item.bjgn }}</td>
                <td class="mobile-hide">{{ item.spffjsyl }}</td>
                <td class="mobile-hide">
                  <a v-if="item.sqrzwmc" :href="'https://www.qcc.com/web/search?key=' + encodeURIComponent(item.sqrzwmc)" target="_blank" class="qcc-link" style="color: #1976D2; cursor: pointer; text-decoration: none;">{{ item.sqrzwmc }}</a>
                  <span v-else>-</span>
                </td>
                <td>{{ item.gxcf }}</td>
              </template>
              <template v-else>
                <td class="tech-snippet-cell" v-html="formatSnippet(item.snippet)"></td>
              </template>

              <!-- 详情按钮 -->
              <td class="action-cell">
                <button class="note-btn" title="备注" @click.stop="openNoteForItem(item)">📝</button>
                <button class="detail-btn original-style" @click="handleDetailClick(item.id)">详情</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 移动端滚动提示 -->
      <div class="scroll-hint mobile-only">
        <span>← 左右滑动查看完整表格，点击产品名称可查看详情 →</span>
      </div>
    </div>

    <!-- 自定义提示框（换证信息） -->
    <div
      v-if="tooltip.visible"
      class="custom-tooltip"
      :style="{
        left: tooltip.x + 'px',
        top: tooltip.y + 'px'
      }"
    >
      <div class="tooltip-content">
        该批文为需要清理证批文，根据国家相关政策换证截止时间为2028年8月31日
        <a
          href="https://www.likangkeji.com/doubleNoList"
          target="_blank"
          class="tooltip-link"
        >详情</a>
      </div>
      <div class="tooltip-arrow"></div>
    </div>

    <!-- 悬浮备注框：鼠标悬停产品名称时显示，点击可编辑 -->
    <div
      v-if="hoverNote.visible"
      class="hover-note-box"
      :style="{ left: hoverNote.x + 'px', top: hoverNote.y + 'px' }"
      @mouseenter="hoverNote.pinned = true"
      @mouseleave="hoverNote.pinned = false"
    >
      <div class="hover-note-title">{{ hoverNote.item ? hoverNote.item.cpmc : '' }}</div>
      <div class="hover-note-content" @click="openNoteDialog(hoverNote.item)">
        <span v-if="hoverNote.note">{{ hoverNote.note }}</span>
        <span v-else class="hover-note-empty">暂无备注，点击编辑</span>
      </div>
      <div class="hover-note-footer">点击备注区域可编辑，下方可选择加入批文库</div>
    </div>

    <!-- 备注编辑对话框 -->
    <el-dialog
      v-model="noteDialog.visible"
      :title="noteDialog.cpmc || '编辑备注'"
      width="480px"
      append-to-body
    >
      <el-input
        v-model="noteDialog.content"
        type="textarea"
        :rows="4"
        placeholder="请输入备注内容（点击空白区域或键盘可直接编辑）"
      />
      <!-- 批文库下拉：默认 '+ 我的批文库'，可选默认批文库/我的批文库/新建批文库 -->
      <div class="pwk-dropdown-row">
        <el-select
          v-model="pwkSelected"
          :placeholder="'＋ 我的批文库'"
          filterable
          class="pwk-select"
          @change="handlePwkSelect"
        >
          <el-option
            v-for="lib in pwkLibs"
            :key="lib.id"
            :label="lib.pwkName + (lib.isDefault === 1 ? '（默认）' : '')"
            :value="lib.id"
          />
          <el-option label="＋ 新建批文库" value="new" />
        </el-select>
        <span class="pwk-tip">将当前批文加入批文库</span>
      </div>
      <template #footer>
        <el-button @click="noteDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveNote">保存备注</el-button>
      </template>
    </el-dialog>

    <!-- 新建批文库对话框 -->
    <el-dialog
      v-model="newPwkDialog.visible"
      title="新建批文库"
      width="400px"
      append-to-body
    >
      <el-input
        v-model="newPwkDialog.name"
        placeholder="请输入批文库名称"
        maxlength="100"
        show-word-limit
        @keyup.enter="createPwk"
      />
      <template #footer>
        <el-button @click="newPwkDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="createPwk">保存</el-button>
      </template>
    </el-dialog>

    <!-- 当前页批量添加批文库：进度/结果弹窗 -->
    <el-dialog
      v-model="batchAddDialog.visible"
      :title="batchAddDialog.phase === 'loading' ? '批量添加批文库' : '添加完成'"
      width="420px"
      :close-on-click-modal="false"
      :show-close="batchAddDialog.phase !== 'loading'"
      append-to-body
    >
      <div v-if="batchAddDialog.phase === 'loading'" class="batch-add-loading">
        <el-icon class="is-loading" :size="26"><Loading /></el-icon>
        <span>正在添加{{ batchAddDialog.pwkName }}</span>
      </div>
      <div v-else class="batch-add-result">
        向{{ batchAddDialog.pwkName }}添加了 {{ batchAddDialog.addedCount }} 条，重复 {{ batchAddDialog.duplicateCount }} 条。
      </div>
      <template #footer>
        <el-button v-if="batchAddDialog.phase === 'done'" type="primary" @click="batchAddDialog.visible = false">确定</el-button>
      </template>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination original-pagination">
      <div class="pagination-info">
        <span>共{{ iTotalRecords }}条</span>
        <select v-model="pageSize" @change="handlePageSizeChange" class="page-size-select">
          <option value="5">5条/页</option>
          <option value="10">10条/页</option>
          <option value="15">15条/页</option>
          <option value="20">20条/页</option>
          <option value="50">50条/页</option>
        </select>
      </div>

      <div class="pagination-controls">
        <button :disabled="currentPage === 1" @click="prevPage" class="page-btn original-style">上一页</button>
        <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
        <button :disabled="currentPage === totalPages" @click="nextPage" class="page-btn original-style">下一页</button>
      </div>

      <div class="pagination-jump">
        <span>跳至：</span>
        <input type="number" v-model="jumpPage" min="1" :max="totalPages" class="page-input">
        <span>页</span>
        <button class="jump-btn original-style" @click="jumpToPage">跳转</button>
      </div>
    </div>

    <MyFooter></MyFooter>
  </div>
</template>

<script setup>
import MyFooter from './MyFooter.vue'
import RootMenu from './RootMenu.vue'
import { ref, onMounted, watch, computed } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'
import config from '../config.js'
import {
  isLoggedIn,
  requireLogin,
  isUnauthorized,
  getPendingAction,
  clearPendingAction,
  isAdminUser
} from '../utils/loginGuard.js'

const router = useRouter()

// 是否已登录（未登录时列表页显示"登录显示全部内容"横幅）
const loggedIn = ref(isLoggedIn())

// 是否管理员（导出按钮仅管理员可见：t_user.role=admin）
const isAdmin = ref(isAdminUser())

// 响应式数据
const pageSize = ref(50)
const totalPages = ref(1)
const currentPage = ref(1)
const cpmc = ref('')
const gxcf = ref('')
const yxqz = ref('')
const symbol = ref('=')
const approvalText = ref('')
const healthFunction = ref('')
const mainIngredients = ref('')
const productionEnterprise = ref('')
const items = ref([])
const jumpPage = ref(1)
const iTotalRecords = ref(0)
const conditions = ref([])
const fieldOptions = ref([])
const showAdvanced = ref(false)
const ingredientName = ref('')
const ingredientValue = ref('')
const techRequirement = ref('')
const sortOption = ref('') // 全局排序，与多字段排序互斥
const tooltip = ref({ visible: false, x: 0, y: 0 })

// ===== 登录提示横幅 =====
const showLoginPrompt = ref(false)

// ===== 悬浮备注 =====
const noteMap = ref({}) // infosharId -> 备注内容（当前页）
const hoverNote = ref({ visible: false, x: 0, y: 0, item: null, note: '', pinned: false })
const noteDialog = ref({ visible: false, infosharId: '', bjspwzId: null, cpmc: '', content: '' })

// ===== 批文库 =====
const pwkLibs = ref([]) // {id, pwkName, isDefault, itemCount}
const pwkSelected = ref('')
const newPwkDialog = ref({ visible: false, name: '' })

// ===== 当前页批量添加批文库 =====
const batchPwkSelected = ref('')
const batchNewFlag = ref(false) // 新建批文库来源标记：true-批量添加下拉，false-备注框下拉
const batchAddDialog = ref({ visible: false, phase: 'loading', pwkName: '', addedCount: 0, duplicateCount: 0 })

// 多字段排序状态对象：存储每个字段的排序方向
const sortOrders = ref({
  pzwh: '',
  gxcf: '',
  // 动态字段将在 updateDynamicColumns 中动态添加
})

// 动态列信息：存储当前显示的动态列字段（用于表头渲染）
const dynamicColumns = ref([])

// FTS 模式：由后端返回的行是否携带 snippet 字段决定，与列展示绑定
const isFtsMode = computed(() => {
  const rows = items.value
  if (!rows || rows.length === 0) return false
  return rows[0].snippet != null && rows[0].snippet !== ''
})

// 剔除 snippet 中相邻汉字之间的空格；<mark> 标签保留
const formatSnippet = (s) => {
  if (!s) return ''
  let prev
  let cur = String(s)
  do {
    prev = cur
    cur = cur.replace(/([一-鿿]) ([一-鿿])/g, '$1$2')
  } while (cur !== prev)
  return cur
}

// 导出数据（CSV，需登录；未登录则先登录，登录后自动继续导出）
const exportData = (paramsOverride) => {
  const params = paramsOverride || buildSearchParams()
  if (!requireLogin(router, '/', { type: 'csv', params })) {
    return
  }
  doExport(params)
}

// 实际执行 CSV 导出（调用后端 /api/listBjsp/export）
const doExport = (params) => {
  ElMessage.info('正在导出 CSV，请稍候...')
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/listBjsp/export`, { params }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {},
    responseType: 'blob',
    timeout: 120000
  }).then(response => {
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = '保健食品批文查询结果.csv'
    a.click()
    URL.revokeObjectURL(url)
  }).catch(error => {
    if (isUnauthorized(error)) {
      ElMessage.warning('登录已过期，请重新登录')
      requireLogin(router, '/', { type: 'csv', params })
      return
    }
    console.error('导出失败:', error)
    ElMessage.error('导出失败，请重试')
  })
}

// 构建当前查询参数（与 fetchData 一致）
const buildSearchParams = () => {
  const queryMap = {}
  conditions.value.forEach(condition => {
    if (condition.field && condition.value) {
      queryMap[condition.field] = condition.value
    }
  })
  let orderBy = ''
  if (sortOption.value) {
    orderBy = sortOption.value
  } else {
    const sortParts = []
    for (const [field, order] of Object.entries(sortOrders.value)) {
      if (order) {
        sortParts.push(`${field} ${order}`)
      }
    }
    if (sortParts.length > 0) {
      orderBy = sortParts.join(',')
    }
  }
  return {
    approvalText: approvalText.value,
    healthFunction: healthFunction.value,
    mainIngredients: mainIngredients.value,
    productionEnterprise: productionEnterprise.value,
    cpmc: cpmc.value,
    gxcf: gxcf.value,
    yxqz: yxqz.value,
    symbol: symbol.value,
    currentPage: currentPage.value,
    pageSize: pageSize.value,
    queryMap: queryMap,
    ingredientName: ingredientName.value,
    ingredientValue: ingredientValue.value,
    techRequirement: techRequirement.value,
    orderBy: orderBy
  }
}

// 横幅"登录"链接：跳转登录页，登录后自动回到首页并加载列表
const handlePromptLogin = () => {
  requireLogin(router, '/', { type: 'page' })
}

// ===== 悬浮备注 =====

// 鼠标悬停产品名称：显示悬浮备注框
const handleRowMouseEnter = (item, event) => {
  const note = noteMap.value[item.infosharId] || ''
  hoverNote.value = {
    visible: true,
    x: Math.min(event.clientX + 10, window.innerWidth - 320),
    y: Math.min(event.clientY + 10, window.innerHeight - 180),
    item,
    note,
    pinned: false
  }
}

// 鼠标离开产品名称：若未固定（鼠标移入备注框）则隐藏
const handleRowMouseLeave = () => {
  setTimeout(() => {
    if (!hoverNote.value.pinned) {
      hoverNote.value.visible = false
    }
  }, 200)
}

// 移动端/备注按钮入口：未登录先登录，登录后自动打开备注对话框
const openNoteForItem = (item) => {
  if (!item || !item.infosharId) {
    ElMessage.warning('该批文缺少唯一标识，无法编辑备注')
    return
  }
  if (!requireLogin(router, '/', {
    type: 'note-open',
    infosharId: item.infosharId,
    bjspwzId: item.id,
    cpmc: item.cpmc || ''
  })) {
    return
  }
  openNoteDialog(item)
}

// 点击悬浮备注框：打开编辑对话框
const openNoteDialog = (item) => {
  hoverNote.value.visible = false
  if (!item || !item.infosharId) {
    ElMessage.warning('该批文缺少唯一标识，无法编辑备注')
    return
  }
  if (!requireLogin(router, '/')) {
    return
  }
  noteDialog.value = {
    visible: true,
    infosharId: item.infosharId,
    bjspwzId: item.id,
    cpmc: item.cpmc || '编辑备注',
    content: noteMap.value[item.infosharId] || ''
  }
  loadPwkLibs()
}

// 保存备注（未登录时先登录，登录后自动保存）
const saveNote = () => {
  const content = noteDialog.value.content || ''
  const infosharId = noteDialog.value.infosharId
  if (!requireLogin(router, '/', { type: 'note-save', infosharId, content })) {
    return
  }
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/note/save`, { infosharId, content }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(() => {
    ElMessage.success('备注已保存')
    noteMap.value[infosharId] = content
    noteDialog.value.visible = false
  }).catch(error => {
    if (isUnauthorized(error)) {
      ElMessage.warning('登录已过期，请重新登录')
      requireLogin(router, '/', { type: 'note-save', infosharId, content })
      return
    }
    ElMessage.error('保存失败，请重试')
  })
}

// 加载当前页所有批文的备注（仅登录后）
const fetchNotesForPage = () => {
  if (!loggedIn.value) {
    noteMap.value = {}
    return
  }
  const ids = items.value.map(i => i.infosharId).filter(id => id)
  if (ids.length === 0) return
  const token = localStorage.getItem('token')
  axios.get(`${config.API_BASE_URL}/api/note/batch`, {
    params: { ids: ids.join(',') },
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(resp => {
    noteMap.value = resp.data.data || {}
  }).catch(() => {
    // 备注加载失败不影响列表展示
  })
}

// ===== 批文库 =====

// 加载当前用户的批文库列表
const loadPwkLibs = () => {
  const token = localStorage.getItem('token')
  axios.get(`${config.API_BASE_URL}/api/pwk/list`, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(resp => {
    pwkLibs.value = resp.data.data || []
  }).catch(() => {
    pwkLibs.value = []
  })
}

// 批文库下拉选择：加入批文库或新建
const handlePwkSelect = (value) => {
  pwkSelected.value = ''
  batchNewFlag.value = false
  const item = noteDialog.value
  if (!item.bjspwzId) return
  if (value === 'new') {
    newPwkDialog.value = { visible: true, name: '' }
    return
  }
  addToPwk(value, item.bjspwzId)
}

// 加入批文库（未登录先登录，登录后自动继续）
const addToPwk = (pwkId, bjspwzId) => {
  if (!requireLogin(router, '/', { type: 'pwk-add', pwkId, bjspwzId })) {
    return
  }
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/pwk/add`, { pwkId, bjspwzId }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(resp => {
    const data = resp.data.data || {}
    if (data.duplicate) {
      ElMessage.info('该批文已在库中（批准文号与申请人相同）')
    } else {
      ElMessage.success('已加入批文库')
    }
  }).catch(error => {
    if (isUnauthorized(error)) {
      ElMessage.warning('登录已过期，请重新登录')
      requireLogin(router, '/', { type: 'pwk-add', pwkId, bjspwzId })
      return
    }
    ElMessage.error('加入批文库失败，请重试')
  })
}

// 新建批文库并加入当前批文（或批量添加当前页，取决于来源）
const createPwk = () => {
  const name = newPwkDialog.value.name.trim()
  if (!name) {
    ElMessage.warning('请输入批文库名称')
    return
  }
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/pwk/create`, { name }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(resp => {
    const data = resp.data.data || {}
    newPwkDialog.value.visible = false
    newPwkDialog.value.name = ''
    loadPwkLibs()
    if (batchNewFlag.value) {
      // 批量添加下拉触发的新建：保存后批量添加当前页
      batchNewFlag.value = false
      batchAddToPwk(data.id, data.pwkName)
    } else if (noteDialog.value.bjspwzId) {
      addToPwk(data.id, noteDialog.value.bjspwzId)
    } else {
      ElMessage.success('批文库创建成功')
    }
  }).catch(error => {
    ElMessage.error(error.response?.data?.message || '创建失败，请重试')
  })
}

// ===== 当前页批量添加批文库 =====

// 点击"当前页批量添加批文库"下拉：未登录先弹出登录窗口
const handleBatchSelectVisible = (visible) => {
  if (!visible) return
  if (!requireLogin(router, '/')) {
    batchPwkSelected.value = ''
    return
  }
  loadPwkLibs()
}

// 批量下拉选择：批量添加当前页或新建批文库
const handleBatchPwkSelect = (value) => {
  batchPwkSelected.value = ''
  if (!value) return
  if (value === 'new') {
    batchNewFlag.value = true
    newPwkDialog.value = { visible: true, name: '' }
    return
  }
  batchNewFlag.value = false
  const lib = pwkLibs.value.find(l => l.id === value)
  batchAddToPwk(value, lib ? lib.pwkName : '批文库')
}

// 执行批量添加（当前分页全部条目加入指定批文库）
const batchAddToPwk = (pwkId, pwkName) => {
  const bjspwzIds = items.value.map(i => i.id).filter(id => id != null)
  if (bjspwzIds.length === 0) {
    ElMessage.warning('当前页没有批文数据，请先搜索')
    return
  }
  batchAddDialog.value = { visible: true, phase: 'loading', pwkName, addedCount: 0, duplicateCount: 0 }
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/pwk/addBatch`, { pwkId, bjspwzIds }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  }).then(resp => {
    const data = resp.data.data || {}
    batchAddDialog.value.phase = 'done'
    batchAddDialog.value.addedCount = data.addedCount || 0
    batchAddDialog.value.duplicateCount = data.duplicateCount || 0
  }).catch(error => {
    batchAddDialog.value.visible = false
    if (isUnauthorized(error)) {
      ElMessage.warning('登录已过期，请重新登录')
      requireLogin(router, '/', { type: 'pwk-batch-add', pwkId, bjspwzIds })
      return
    }
    ElMessage.error('批量添加失败，请重试')
  })
}

// 检查登录状态
const checkLogin = () => {
  const token = localStorage.getItem('token')
  return !!token
}

// 小程序环境直接跳转原生登录页
const navigateToWxLogin = () => {
  if (window.wx && window.wx.miniProgram) {
    window.wx.miniProgram.postMessage({ action: 'login' })
    window.wx.miniProgram.navigateTo({ url: '/pages/login/login' })
  }
}

// 搜索前的登录检查（未登录先保存搜索参数，登录后自动继续查询，无需重新填参）
const checkLoginBeforeSearch = () => {
  if (!checkLogin()) {
    requireLogin(router, '/', { type: 'search', params: buildSearchParams() })
  } else {
    fetchData(1)
  }
}

// 高级查询前的登录检查
const checkLoginBeforeAdvancedSearch = () => {
  if (!checkLogin()) {
    const isWxMini = /miniProgram/i.test(navigator.userAgent)
    if (isWxMini) {
      navigateToWxLogin()
      return
    }
    router.push({ name: 'login', query: { from: 'advancedSearch' } })
  } else {
    toggleAdvancedSearch()
  }
}

// 保存搜索条件到 sessionStorage
const saveSearchState = () => {
  const searchState = {
    cpmc: cpmc.value,
    gxcf: gxcf.value,
    yxqz: yxqz.value,
    symbol: symbol.value,
    approvalText: approvalText.value,
    healthFunction: healthFunction.value,
    mainIngredients: mainIngredients.value,
    productionEnterprise: productionEnterprise.value,
    pageSize: pageSize.value,
    currentPage: currentPage.value,
    ingredientName: ingredientName.value,
    ingredientValue: ingredientValue.value,
    techRequirement: techRequirement.value,
    sortOption: sortOption.value,
    conditions: conditions.value,
    sortOrders: sortOrders.value,
    showAdvanced: showAdvanced.value
  }
  sessionStorage.setItem('searchState', JSON.stringify(searchState))
}

// 从 sessionStorage 恢复搜索条件
const restoreSearchState = () => {
  const savedState = sessionStorage.getItem('searchState')
  if (savedState) {
    const state = JSON.parse(savedState)
    cpmc.value = state.cpmc || ''
    gxcf.value = state.gxcf || ''
    yxqz.value = state.yxqz || ''
    symbol.value = state.symbol || '='
    approvalText.value = state.approvalText || ''
    healthFunction.value = state.healthFunction || ''
    mainIngredients.value = state.mainIngredients || ''
    productionEnterprise.value = state.productionEnterprise || ''
    pageSize.value = state.pageSize || 50
    currentPage.value = state.currentPage || 1
    ingredientName.value = state.ingredientName || ''
    ingredientValue.value = state.ingredientValue || ''
    techRequirement.value = state.techRequirement || ''
    sortOption.value = state.sortOption || ''
    conditions.value = state.conditions || []
    sortOrders.value = state.sortOrders || { pzwh: '', gxcf: '' }
    showAdvanced.value = state.showAdvanced || false
    // 恢复动态列
    updateDynamicColumns()
  }
}

// 清除搜索状态
const clearSearchState = () => {
  sessionStorage.removeItem('searchState')
}

// 产品名称点击跳转详情
const handleProductNameClick = (itemId) => {
  saveSearchState()
  router.push({ name: 'detail', params: { id: itemId } })
}

// 详情按钮点击（同一页面跳转）
const handleDetailClick = (itemId) => {
  saveSearchState()
  router.push({ name: 'detail', params: { id: itemId } })
}

// 获取字段选项（用于动态列）
const fetchfieldOptions = async () => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/api/metaTable/getMetaTableList?tableName=bjspwz`)
    fieldOptions.value = response.data.data.aaData
  } catch (error) {
    console.error('获取批文转让数据失败:', error)
  }
}

// 添加一个查询条件
const addCondition = () => {
  conditions.value.push({ field: '', value: '' })
}

// 移除一个查询条件
const removeCondition = (index) => {
  conditions.value.splice(index, 1)
  updateDynamicColumns()
}

// 当条件字段变化时更新动态列
const updateDynamicColumns = () => {
  // 根据 conditions 中非空的 field 生成动态列
  const newCols = conditions.value
    .filter(c => c.field && c.field.trim() !== '')
    .map(c => ({ field: c.field }))

  // 更新 dynamicColumns
  dynamicColumns.value = newCols

  // 在 sortOrders 中为新的动态字段初始化排序状态（保留原有值，新字段默认为空）
  const newSortOrders = { ...sortOrders.value }
  // 移除不再存在的字段的排序状态（可选，也可以保留）
  Object.keys(newSortOrders).forEach(key => {
    if (key !== 'pzwh' && key !== 'gxcf' && !newCols.some(col => col.field === key)) {
      delete newSortOrders[key]
    }
  })
  // 添加新字段
  newCols.forEach(col => {
    if (!(col.field in newSortOrders)) {
      newSortOrders[col.field] = ''
    }
  })
  sortOrders.value = newSortOrders
}

// 获取字段注释
const getColumnLabel = (field) => {
  const opt = fieldOptions.value.find(o => o.columnName === field)
  return opt ? opt.commitName : field
}

// 处理全局排序变化（当用户选择全局排序时，清空多字段排序）
const handleGlobalSortChange = () => {
  // 清空所有字段排序
  Object.keys(sortOrders.value).forEach(key => {
    sortOrders.value[key] = ''
  })
  fetchData(1)
}

// 处理字段排序变化（当用户选择字段排序时，清空全局排序）
const handleFieldSortChange = () => {
  // 清空全局排序选项
  sortOption.value = ''
  fetchData(1)
}

// 切换高级查询
const toggleAdvancedSearch = () => {
  showAdvanced.value = !showAdvanced.value
}

// 重置搜索条件
const resetSearch = () => {
  cpmc.value = ''
  approvalText.value = ''
  healthFunction.value = ''
  mainIngredients.value = ''
  productionEnterprise.value = ''
  gxcf.value = ''
  yxqz.value = ''
  symbol.value = '='
  ingredientName.value = ''
  ingredientValue.value = ''
  techRequirement.value = ''
  sortOption.value = ''
  conditions.value = []
  dynamicColumns.value = []
  // 重置排序状态
  sortOrders.value = { pzwh: '', gxcf: '' }
  currentPage.value = 1
  // 清除保存的搜索状态
  clearSearchState()
  fetchData()
}

// 分页相关方法
const handlePageSizeChange = () => {
  currentPage.value = 1
  fetchData()
}

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
    fetchData()
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
    fetchData()
  }
}

const jumpToPage = () => {
  const page = parseInt(jumpPage.value)
  if (page >= 1 && page <= totalPages.value) {
    fetchData(page)
  } else {
    ElMessage.warning(`请输入有效的页码（1-${totalPages.value}）`)
  }
}

// 主查询方法（支持多字段排序）
const fetchData = (page) => {
  if (!page || page === 1) {
    page = currentPage.value
  }

  const queryMap = {}
  conditions.value.forEach(condition => {
    if (condition.field && condition.value) {
      queryMap[condition.field] = condition.value
    }
  })

  // 构建排序字符串：如果全局排序 sortOption 有值，则优先使用全局排序（与多字段互斥）
  let orderBy = ''
  if (sortOption.value) {
    // 全局排序对应后端固定的两个选项
    orderBy = sortOption.value
  } else {
    // 收集所有非空的排序字段
    const sortParts = []
    for (const [field, order] of Object.entries(sortOrders.value)) {
      if (order) {
        sortParts.push(`${field} ${order}`)
      }
    }
    if (sortParts.length > 0) {
      orderBy = sortParts.join(',')
    }
  }

  const par1 = {
    approvalText: approvalText.value,
    healthFunction: healthFunction.value,
    mainIngredients: mainIngredients.value,
    productionEnterprise: productionEnterprise.value,
    cpmc: cpmc.value,
    gxcf: gxcf.value,
    yxqz: yxqz.value,
    symbol: symbol.value,
    currentPage: page,
    pageSize: pageSize.value,
    queryMap: queryMap,
    ingredientName: ingredientName.value,
    ingredientValue: ingredientValue.value,
    techRequirement: techRequirement.value,
    // 传递排序参数
    orderBy: orderBy // 后端需解析此字段
  }

  console.log('发送请求参数:', par1)
  console.log('orderBy参数:', orderBy)

  // /api/listBjsp 需身份标识：附加登录 token（未登录时后端返回 401 -> 显示"登录显示全部内容"横幅）
  const token = localStorage.getItem('token')
  axios.post(`${config.API_BASE_URL}/api/listBjsp`, { params: par1 }, {
    headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
  })
    .then(response => {
      showLoginPrompt.value = false
      currentPage.value = response.data.data.number
      totalPages.value = response.data.data.totalPages
      items.value = response.data.data.aaData
      iTotalRecords.value = response.data.data.iTotalRecords
      fetchNotesForPage()
    })
    .catch(error => {
      if (isUnauthorized(error)) {
        // 未登录：列表区显示"登录显示全部内容"横幅，不跳转（首页自动调取）
        showLoginPrompt.value = true
        items.value = []
        iTotalRecords.value = 0
        totalPages.value = 1
        return
      }
      console.error('Search failed:', error)
      ElMessage.error('搜索失败，请重试')
    })
}

// 监听 conditions 变化，自动更新动态列
watch(conditions, () => {
  updateDynamicColumns()
}, { deep: true })

// 组件挂载时初始化
onMounted(() => {
  symbol.value = "等于"
  sortOption.value = ""
  fetchfieldOptions()
  // 登录后自动续做任务：搜索/CSV 导出（登录前点击搜索/导出 -> 登录 -> 自动执行剩余流程，无需重新填参）
  const pending = getPendingAction()
  if (pending && (pending.type === 'csv' || pending.type === 'search')) {
    clearPendingAction()
    if (pending.params) {
      const p = pending.params
      cpmc.value = p.cpmc || ''
      gxcf.value = p.gxcf || ''
      yxqz.value = p.yxqz || ''
      symbol.value = p.symbol || '='
      approvalText.value = p.approvalText || ''
      healthFunction.value = p.healthFunction || ''
      mainIngredients.value = p.mainIngredients || ''
      productionEnterprise.value = p.productionEnterprise || ''
      ingredientName.value = p.ingredientName || ''
      ingredientValue.value = p.ingredientValue || ''
      techRequirement.value = p.techRequirement || ''
      sortOption.value = p.sortOption || ''
      pageSize.value = p.pageSize || 50
      sortOrders.value = p.sortOrders || { pzwh: '', gxcf: '' }
      conditions.value = p.conditions || []
      updateDynamicColumns()
      fetchData(1)
      if (pending.type === 'csv') {
        exportData(p)
      }
      return
    }
  }
  // 登录后自动打开备注对话框（登录前点击备注 -> 登录 -> 自动继续编辑）
  if (pending && pending.type === 'note-open' && pending.infosharId) {
    clearPendingAction()
    const token = localStorage.getItem('token')
    axios.get(`${config.API_BASE_URL}/api/note/get`, {
      params: { infosharId: pending.infosharId },
      headers: token ? { Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}` } : {}
    }).then(resp => {
      noteDialog.value = {
        visible: true,
        infosharId: pending.infosharId,
        bjspwzId: pending.bjspwzId,
        cpmc: pending.cpmc || '编辑备注',
        content: (resp.data.data || {}).content || ''
      }
      loadPwkLibs()
    }).catch(() => {
      ElMessage.error('加载备注失败，请重试')
    })
  }
  // 检查是否有保存的搜索状态
  if (sessionStorage.getItem('searchState')) {
    restoreSearchState()
    // 恢复后重新获取数据
    fetchData()
  } else {
    fetchData()
  }
})
</script>

<style scoped>
/* ========== 原有样式完整保留 ========== */
.app-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
}

.search-bar {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 20px;
  border-radius: 8px;
  margin: 10px 20px 20px 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.search-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.search-field {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.search-field label {
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.search-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.search-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.button-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.original-style {
  padding: 10px 30px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 100px;
  transition: all 0.3s ease;
}

.search-btn.original-style {
  background: #409eff;
  color: white;
}

.reset-btn.original-style {
  background: #f56c6c;
  color: white;
}

.export-btn.original-style {
  background: #67c23a;
  color: white;
}

.search-btn.original-style:hover {
  background: #66b1ff;
  transform: translateY(-2px);
}

.reset-btn.original-style:hover {
  background: #f78989;
  transform: translateY(-2px);
}

.export-btn.original-style:hover {
  background: #85ce61;
  transform: translateY(-2px);
}

.detail-btn.original-style {
  background-color: #007BFF;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.detail-btn.original-style:hover {
  background-color: #0056b3;
  transform: translateY(-1px);
}

.page-btn.original-style {
  padding: 8px 15px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-btn.original-style:hover:not(:disabled) {
  background: #409eff;
  color: white;
  border-color: #409eff;
  transform: translateY(-1px);
}

.page-btn.original-style:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.jump-btn.original-style {
  padding: 5px 10px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.jump-btn.original-style:hover {
  background: #66b1ff;
  transform: translateY(-1px);
}

.original-table {
  border-collapse: collapse;
  width: 100%;
  min-width: 1000px;
}

.original-table th {
  background-color: #0056b3;
  color: white;
  position: sticky;
  top: 0;
  z-index: 10;
  border: 1px solid #e1e5e9;
  padding: 14px 12px;
  text-align: left;
  min-width: 100px;
  font-weight: 500;
  font-size: 14px;
}

.original-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  min-width: 120px;
}

.advanced-search-toggle {
  text-align: center;
  margin: 15px 0;
  padding: 10px 0;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.advanced-search-btn {
  color: #409eff;
  font-size: 14px;
}

.advanced-search-btn i {
  margin-left: 5px;
  transition: transform 0.3s;
}

.advanced-search-panel {
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 20px;
  margin: 15px 0;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-content {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  background: white;
  color: #2c3e50;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  font-size: 14px;
  line-height: 1.5;
}

.tooltip-content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-content {
  opacity: 1;
  visibility: visible;
}

.table-container {
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  margin: 0 20px 20px 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: relative;
}

.table-responsive {
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e0e0e0;
  max-height: 90vh;
  position: relative;
}

.scrollable-table {
  border-collapse: collapse;
  width: 100%;
  min-width: 1000px;
}

.scrollable-table thead {
  position: sticky;
  top: 0;
  z-index: 100;
}

.approval-number-cell {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
}

.certificate-flag {
  position: absolute;
  top: 2px;
  left: 2px;
  display: inline-block;
}

.flag-icon {
  width: 25px;
  height: 25px;
  vertical-align: top;
}

.custom-tooltip {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  max-width: 300px;
  font-size: 14px;
  line-height: 1.4;
  animation: fadeIn 0.2s ease-in-out;
  pointer-events: none;
}

.tooltip-link {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
  margin-left: 4px;
}

.tooltip-link:hover {
  text-decoration: underline;
}

.tooltip-arrow {
  position: absolute;
  top: -6px;
  left: 10px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}

.tooltip-arrow::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -7px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ddd;
  z-index: -1;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.scroll-hint {
  display: none;
  text-align: center;
  padding: 8px;
  background: #f8f9fa;
  color: #6c757d;
  font-size: 12px;
  border-top: 1px solid #e9ecef;
  animation: pulse 2s infinite;
}

.mobile-only {
  display: none;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}

.original-pagination {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  margin: 0 20px 20px 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  flex-wrap: wrap;
  gap: 15px;
}

.pagination-info, .pagination-controls, .pagination-jump {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-size-select, .page-input {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.page-info {
  margin: 0 10px;
}

/* ========== 新增样式 ========== */
/* 产品名称点击样式（蓝色） */
.clickable-name {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.2s;
}
.clickable-name:hover {
  text-decoration-color: #409eff;
}

.qcc-link:hover {
  text-decoration: underline;
}

/* 表头内排序下拉样式 */
.th-content {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.sort-select-inline {
  font-size: 12px;
  padding: 2px 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  width: 55px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .mobile-hide {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .scroll-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 12px;
    background: #f8f9fa;
    color: #6c757d;
    font-size: 13px;
    border-top: 1px solid #e9ecef;
    animation: pulse 2s infinite;
  }

  .scrollable-table {
    min-width: 800px;
  }

  .scrollable-table td {
    padding: 12px;
    min-width: 100px;
    font-size: 14px;
  }

  .table-responsive {
    margin-bottom: 5px;
    max-height: 60vh;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }

  .approval-number-cell {
    padding-left: 20px;
  }

  .flag-icon {
    width: 14px;
    height: 14px;
  }

  .custom-tooltip {
    max-width: 250px;
    font-size: 12px;
    padding: 10px;
  }

  table {
    min-width: 600px;
  }

  th, td {
    padding: 8px 6px;
    font-size: 12px;
    min-width: 100px;
  }

  .search-bar {
    margin: 10px 10px 15px 10px;
    padding: 15px;
  }

  .search-row {
    flex-direction: column;
    gap: 10px;
  }

  .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .original-style {
    width: 100%;
    padding: 12px;
  }

  .batch-pwk-select-wrap {
    width: 100%;
    flex: 1 1 auto;
  }

  .table-container {
    margin: 0 10px 15px 10px;
    padding: 15px 10px;
  }

  .original-pagination {
    margin: 0 10px 15px 10px;
    padding: 15px;
    flex-direction: column;
    gap: 15px;
  }

  .pagination-info, .pagination-controls, .pagination-jump {
    width: 100%;
    justify-content: center;
  }

  .app-container {
    max-width: 100%;
    padding: 0 10px;
  }

  .advanced-search-panel {
    padding: 15px;
    margin: 10px 0;
  }

  .dialog-search-row {
    flex-direction: column;
    gap: 10px;
  }

  .search-input, .symbol-select, .page-size-select, .page-input {
    font-size: 16px;
    padding: 12px 15px;
  }

  /* 移动端表头排序下拉适配 */
  .th-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
  .sort-select-inline {
    width: 50px;
    font-size: 11px;
    padding: 1px 3px;
  }
}

/* 电脑端优化 */
@media (min-width: 769px) {
  .button-group {
    max-width: 600px;
    margin: 0 auto;
  }

  .button-group .original-style {
    min-width: 120px;
    flex: 1;
    max-width: 200px;
  }
}

/* 大屏幕优化 */
@media (min-width: 1200px) {
  .search-bar, .table-container, .original-pagination {
    margin-left: 40px;
    margin-right: 40px;
  }

  .scrollable-table {
    min-width: 1200px;
  }

  .button-group {
    max-width: 800px;
  }

  .button-group .original-style {
    min-width: 150px;
    max-width: 250px;
  }
}

/* 平板设备优化 */
@media (min-width: 769px) and (max-width: 1024px) {
  .search-bar, .table-container, .original-pagination {
    margin-left: 20px;
    margin-right: 20px;
  }

  .button-group {
    gap: 15px;
  }

  .button-group .original-style {
    min-width: 100px;
    max-width: 180px;
  }
}

/* 移动端登录提示（如有需要） */
.mobile-login-prompt {
  display: none;
  text-align: center;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  margin: 10px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.mobile-login-prompt p {
  margin: 0 0 10px 0;
  font-size: 14px;
}

.mobile-login-btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s;
}

.mobile-login-btn:active {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .mobile-login-prompt {
    display: block;
  }
}
</style>

<style>
/* 全局样式 - 彻底消除白边和背景图 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background-color: #f5f5f5;
}

#app {
  background: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  font-family: Arial, sans-serif;
}

/* 滚动条样式优化 */
.table-responsive::-webkit-scrollbar {
  height: 16px;
  width: 16px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 8px;
  border: 3px solid #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* ===== 登录提示横幅 ===== */
.login-prompt-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 10px 20px;
  padding: 18px 20px;
  background: linear-gradient(135deg, #fff7e6, #fff3d9);
  border: 1px solid #ffd591;
  border-radius: 8px;
  flex-wrap: wrap;
}

.prompt-text {
  font-size: 18px;
  font-weight: 700;
  color: #d46b08;
}

.prompt-login-link {
  font-size: 16px;
  font-weight: 700;
  color: #409eff;
  text-decoration: none;
  padding: 6px 22px;
  border: 1px solid #409eff;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.prompt-login-link:hover {
  background: #409eff;
  color: #fff;
}

.prompt-sub {
  font-size: 13px;
  color: #8c6d2f;
}

/* ===== 悬浮备注框 ===== */
.hover-note-box {
  position: fixed;
  z-index: 2000;
  width: 300px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 10px 14px;
  cursor: pointer;
}

.hover-note-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hover-note-content {
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
  max-height: 90px;
  overflow-y: auto;
  padding: 8px;
  background: #f7f8fa;
  border-radius: 6px;
  min-height: 30px;
}

.hover-note-empty {
  color: #909399;
}

.hover-note-footer {
  margin-top: 6px;
  font-size: 11px;
  color: #b0b3b8;
  text-align: right;
}

/* ===== 备注对话框内的批文库下拉 ===== */
.pwk-dropdown-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.pwk-select {
  width: 220px;
}

.pwk-tip {
  font-size: 12px;
  color: #909399;
}

/* ===== 当前页批量添加批文库下拉（搜索按钮组内） ===== */
/* Element Plus 的 .el-select 自带 flex:1，会撑满按钮组，需用固定宽度容器包裹 */
.batch-pwk-select-wrap {
  width: 200px;
  min-width: 200px;
  flex: 0 0 200px;
}

/* ===== 批量添加进度/结果弹窗 ===== */
.batch-add-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 0;
  font-size: 15px;
  color: #303133;
}

.batch-add-loading .el-icon {
  color: #409eff;
}

.batch-add-result {
  padding: 12px 0;
  font-size: 15px;
  color: #303133;
  line-height: 1.6;
}

/* ===== 列表操作列（备注按钮） ===== */
.action-cell {
  white-space: nowrap;
}

.note-btn {
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.note-btn:hover {
  border-color: #409eff;
  background: #ecf5ff;
}
</style>
